













































import { Vue, Component } from 'vue-property-decorator'

import { currentUserIs, UserRole } from '@/types/Users'
import { Job } from '@/types/Jobs'
import { loadJobs } from '@/services/jobs'
import { loadWorkforce } from '@/services/users'

import GMap from '@/components/GMap.vue'
import JobsList from '@/components/JobsList.vue'
import EditJobDialog from './EditJobDialog.vue'

@Component({
  components: { JobsList, GMap, EditJobDialog },
})
export default class JobsView extends Vue {

  loading = false
  createJobDialog = false

  metaInfo() {
    return { title: 'Jobs' }
  }

  async mounted() {
    this.loading = true
    try {
      await loadJobs(this.$store)
      await loadWorkforce(this.$store)
    }
    finally {
      this.loading = false
    }
  }

  get directJobs(): Job[] {
    return this.$store.getters.directJobs
  }

  get indirectJobs(): Job[] {
    return this.$store.getters.indirectJobs
  }

  get allJobs(): Job[] {
    return [...this.directJobs, ...this.indirectJobs]
  }

  get userIsOrgManager() {
    return currentUserIs(UserRole.Admin)
  }

  get workforce() {
    return this.$store.getters.workforce
  }
}
